<template>
  <div class="down_goods_confirm">
    <van-icon name="cross" class="cross" @click="close" />
    <div class="tit">是否下架此商品</div>
    <div class="btns">
      <van-button round class="back_btn" @click="close">再想想</van-button>
      <van-button round color="var(--theme)" @click="confirm" :loading="loading">确认下架</van-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false
    }
  },
  props: {
    selection: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    close() {
      this.$emit('closeModal')
    },
    confirm() {
        this.loading = true
        this.$Ajax('v2/goods/cancel',{goods_id: this.selection.goods_id},'get').then(rs => {
            if(rs.code == 200) {
                this.$toast({
                    message: '下架成功',
                    duration: "2000",
                    onClose: () => {
                        this.$emit('success')
                    }
                })
            }else {
                this.$toast({
                    message: rs.msg,
                    duration: "2000"
                })
            }
        }).finally(() => {
            setTimeout(() => {
                this.loading = false
            },1000)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.down_goods_confirm {
  position: relative;
  padding: 2.9rem 1.5rem 2.2rem;

  .cross {
    position: absolute;
    right: .8rem;
    top: .8rem;
    font-size: 1.8rem;
    color: #000;
    cursor: pointer;
  }

  .tit {
    font-size: 1.6rem;
    text-align: center;
    font-weight: 700;
    margin-bottom: 2.4rem;
    color: var(--theme);
  }

  .btns {
    display: flex;
    justify-content: space-between;

    .van-button {
      width: 12rem;
      height: 3.2rem;
      padding: 0;
      font-size: 1.4rem;
    }

    .back_btn {
      border-color: #999;
      color: #999;
    }
  }
}
</style>